<template>
  <div class="rsvp page">
    <h2 class="h2">Hello {{ name }}. Please complete the form below</h2>
    <p class="p">
      Please let us know your intent to attend our wedding by submitting your
      mailing address to register for our wedding card.
    </p>
    <div class="form-area">
      <div class="inputs-area">
        <div class="input-block">
          <label class="label">
            Name:
          </label>
          <input
            class="input"
            type="text"
            v-on:keyup.enter="submitForm"
            ref="firstLine"
            v-model="newGuest.name"
          />
        </div>
        <div class="input-block">
          <label class="label">
            Email:
          </label>
          <input
            class="input"
            type="text"
            v-on:keyup.enter="submitForm"
            ref="firstLine"
            v-model="newGuest.email"
          />
        </div>
        <div class="input-block">
          <label class="label">
            Address First Line:
          </label>
          <input
            class="input"
            type="text"
            v-on:keyup.enter="submitForm"
            ref="firstLine"
            v-model="newGuest.firstLine"
          />
        </div>
        <div class="input-block">
          <label class="label">
            Address Second Line:
          </label>
          <input
            class="input input-password"
            type="text"
            v-on:keyup.enter="submitForm"
            ref="sedcondLine"
            v-model="newGuest.sedcondLine"
          />
        </div>
        <div class="input-block">
          <label class="label">
            City / Town:
          </label>
          <input
            class="input input-password"
            type="text"
            v-on:keyup.enter="submitForm"
            ref="city"
            v-model="newGuest.city"
          />
        </div>
        <div class="input-block">
          <label class="label">
            State / County:
          </label>
          <input
            class="input input-password"
            type="text"
            v-on:keyup.enter="submitForm"
            ref="county"
            v-model="newGuest.county"
          />
        </div>
        <div class="input-block">
          <label class="label">
            Country:
          </label>
          <input
            class="input input-password"
            type="text"
            v-on:keyup.enter="submitForm"
            ref="country"
            v-model="newGuest.country"
          />
        </div>
        <div class="input-block">
          <label class="label">
            Post / Zip Code:
          </label>
          <input
            class="input input-password"
            type="text"
            v-on:keyup.enter="submitForm"
            ref="postcode"
            v-model="newGuest.postcode"
          />
        </div>
      </div>
      <div class="message">
        <span class="message-title" v-show="success">
          Form submitted, thank you for registering.
        </span>
      </div>
      <div class="form-bottom">
        <div class="submit-button">
          <button @click.prevent="addGuest" class="button">
            Register
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

import "firebase/database";

let config = {
  apiKey: "AIzaSyBASn71cRoOkQVEqACUP8zwgpVz4G7SvBU",
  authDomain: "the-bardailongs-wedding.firebaseapp.com",
  databaseURL: "https://the-bardailongs-wedding.firebaseio.com",
  projectId: "the-bardailongs-wedding",
  storageBucket: "the-bardailongs-wedding.appspot.com",
  messagingSenderId: "743089735471",
  appId: "1:743089735471:web:dc289eeb48cafb3f6843da"
};

let app = firebase.initializeApp(config);
let db = app.database();
let guestsRef = db.ref("guests");

export default {
  name: "rsvp",
  props: ["email", "name"],
  data() {
    return {
      success: false,
      newGuest: {
        name: this.name,
        email: this.email,
        firstLine: "",
        sedcondLine: "",
        city: "",
        county: "",
        country: "",
        postcode: ""
      }
    };
  },
  firebase: {
    guests: guestsRef
  },
  methods: {
    addGuest: function() {
      this.newGuest.email = this.email;
      this.newGuest.name = this.name;
      guestsRef.push(this.newGuest);
      this.newGuest.firstLine = "";
      this.newGuest.sedcondLine = "";
      this.newGuest.city = "";
      this.newGuest.county = "";
      this.newGuest.country = "";
      this.newGuest.postcode = "";
      this.success = true;
    }
  }
};
</script>

<style lang="scss">
@import "src/scss/base.scss";

.rsvp {
  max-width: 515px;
}

.title-main {
  max-width: 420px;
  margin-bottom: 50px;
}

.form-area {
  display: flex;
  flex-direction: column;
}

.inputs-area {
  display: flex;
  flex-direction: column;
  margin-bottom: 28px;
  margin-top: 44px;
}

.h2 {
  text-align: center;
}

.input-block {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.label {
  flex: 0 0 210px;
  margin: 10px 0;
}

.input {
  flex: 1;
  font-family: "Cinzel", serif;
  padding: 8px 15px;
  font-size: $font-size-normal;
  border: 1px solid #333333;
  border-radius: 4px;
  outline: none;
  color: #564f49;
}

.errors {
  margin-bottom: 12px;
}

.form-bottom {
  display: flex;
  margin-bottom: 42px;
  justify-content: flex-end;
}

.submit-button {
  width: 140px;
}

.message {
  display: flex;
  justify-content: center;
}

.message-title {
  padding: 0 20px 40px 20px;
}
</style>
